//get some polyfills for ie blegh
import 'react-app-polyfill/ie11';
import 'core-js/fn/array/find';
import 'core-js/fn/array/includes';
import 'core-js/fn/number/is-nan';

import React from 'react'
import ReactDOM from 'react-dom'
import './css/App.css'
import registerServiceWorker from './registerServiceWorker'

import { Provider } from 'react-redux'
import store from './store/configureStore'
import { BrowserRouter } from 'react-router-dom'

import App from './containers/App'

ReactDOM.render(
	<Provider store={store}>
		<BrowserRouter>
			<App/>
		</BrowserRouter>
	</Provider>,
	document.getElementById('root')
)

registerServiceWorker()


// WEBPACK FOOTER //
// ./src/index.js